// components
import MaterialTypography from '@mui/material/Typography'

export default MaterialTypography
